import React, { Component } from "react";
import styled from "styled-components";
import PS from "../../MonitoringApiService";

// 전력량계 응답의 type별 섹션 타이틀
const METER_TITLE_BY_TYPE = {
  HS: "전력량계(수용가)",
  PV: "태양광",
};

class DetailMeterSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meterSerialNos: this.props.meterSerialNos,
      meterData: this.props.meterData,
      meterMonitoringData: [],
    };
  }

  componentDidMount() {
    if (this.state.meterSerialNos && this.state.meterSerialNos.length > 0) {
      this.getMeterData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.meterSerialNos !== this.props.meterSerialNos) {
      this.setState({ meterSerialNos: this.props.meterSerialNos }, () => this.getMeterData());
    }
    if (prevProps.meterData !== this.props.meterData) {
      this.setState({ meterData: this.props.meterData });
    }
  }

  getMeterData = async () => {
    const { meterSerialNos } = this.state;
    try {
      const res = await PS.getMeterList({
        serialNos: meterSerialNos
      });

      this.setState({
        meterMonitoringData: res || [],
      });
    } catch (error) {
      this.setState({
        meterMonitoringData: [],
      });
      console.error("Error fetching meter data: ", error);
    }
  }

  // type이 같은 응답들을 하나의 섹션 데이터로 합산
  calculateTotals = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return {
        totalRCumActivePower: 0,
        totalRActivePower: 0,
        totalSActivePower: 0,
        totalSCumActivePower: 0,
      };
    }

    return data.reduce((acc, item) => {
      return {
        totalRCumActivePower: acc.totalRCumActivePower + (item.rCumActivePower || 0),
        totalRActivePower: acc.totalRActivePower + (item.rActivePower || 0),
        totalSActivePower: acc.totalSActivePower + (item.sActivePower || 0),
        totalSCumActivePower: acc.totalSCumActivePower + (item.sCumActivePower || 0),
      };
    }, {
      totalRCumActivePower: 0,
      totalRActivePower: 0,
      totalSActivePower: 0,
      totalSCumActivePower: 0,
    });
  }

  // 숫자를 포맷팅하는 헬퍼 함수 (kWh로 변환하고 콤마 추가)
  formatPower = (value, baseUnit) => {
    // 음수인 경우 부호를 분리
    const isNegative = value < 0;
    const absValue = Math.abs(value);

    let displayValue;
    let displayUnit;

    // 1000 단위로 자동 변환
    if (absValue >= 1000) {
      displayValue = absValue / 1000;
      // baseUnit이 'W'면 'kW', 'Wh'면 'kWh'로 변환
      displayUnit = baseUnit === 'W' ? 'kW' : 'kWh';
    } else {
      displayValue = absValue;
      displayUnit = baseUnit;
    }

    // 콤마 추가 및 소수점 2자리
    const formatted = displayValue.toLocaleString('ko-KR', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });

    // 음수인 경우 - 부호 추가
    const finalValue = isNegative ? `-${formatted}` : formatted;

    return { value: finalValue, unit: displayUnit };
  }

  // 송전 유효전력 전용: kW로 자동 변환하지 않고 항상 W로 표시
  formatPowerAsW = (value) => {
    const isNegative = value < 0;
    const formatted = Math.abs(value).toLocaleString('ko-KR', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
    return { value: isNegative ? `-${formatted}` : formatted, unit: 'W' };
  }

  render() {
    const { meterData, meterMonitoringData } = this.state;

    // type(HS/PV 등)별로 그룹핑해서 섹션을 각각 노출
    const groupsByType = meterMonitoringData.reduce((acc, item) => {
      const type = item.type || "HS";
      if (!acc[type]) acc[type] = [];
      acc[type].push(item);
      return acc;
    }, {});

    return (
      <>
        {Object.keys(groupsByType).map((type) => {
          const items = groupsByType[type];
          const totals = this.calculateTotals(items);
          const rCumPower = this.formatPower(totals.totalRCumActivePower, 'Wh');
          const rPower = this.formatPower(totals.totalRActivePower, 'W');
          const sPower = this.formatPowerAsW(totals.totalSActivePower);
          const sCumPower = this.formatPower(totals.totalSCumActivePower, 'Wh');
          const title = METER_TITLE_BY_TYPE[type] || METER_TITLE_BY_TYPE.HS;

          return (
            <Section key={type}>
              <SectionTitle>
                <h3>{title}</h3>
              </SectionTitle>
              <ContentDetail>
                <DeviceDetailHeader>
                  <div className="head">
                    {meterData[0]?.data?.name || ""}
                  </div>
                  <span>
                    {items.length > 0 ? items[0]?.time : "--"}
                  </span>
                </DeviceDetailHeader>
                <div className="info-list">
                  <dl>
                    <dt>수전 적산유효전력량</dt>
                    <dd>{rCumPower.value} {rCumPower.unit}</dd>
                  </dl>
                  <dl>
                    <dt>수전 유효전력</dt>
                    <dd>{rPower.value} {rPower.unit}</dd>
                  </dl>
                  <dl>
                    <dt>송전 적산유효전력량</dt>
                    <dd>{sCumPower.value} {sCumPower.unit}</dd>
                  </dl>
                  <dl>
                    <dt>송전 유효전력</dt>
                    <dd>{sPower.value} {sPower.unit}</dd>
                  </dl>
                </div>
              </ContentDetail>
            </Section>
          );
        })}
      </>
    );
  }
}

export default DetailMeterSection;

const Section = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: solid 1px #000;
`;

const SectionTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: column;
  align-items: center;
  padding: 30px 0 15px;
  .full-power {
    text-align: right;
    p {
      display: inline-block;
      vertical-align: middle;
      padding: 0 12px 0 0;
    }
  }
`;

const ContentDetail = styled.div`
  background-color: #f2f3f5;
  border-radius: 12px;
  padding: 20px;
  margin-top: 12px;
  .info-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    dt,
    dd {
      display: inline-block;
      vertical-align: middle;
      padding: 10px 0;
      font-size: 14px;
      font-weight: 500;
      color: #191919;
    }
    dt {
      ${({ dtWidth }) => dtWidth ? `width: ${dtWidth};` : `width: 120px;`}
    }
    dd {
      padding-left: 30px;
    }
    span {
      display: inline-block;
      vertical-align: top;
    }
  }
`;

const DeviceDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #b5b5b5;
  .head {
    font-weight: 600;
  }
  span {
    font-size: 14px;
    color: #797979;
  }
`;
